// extracted by css-extract-rspack-plugin
export default {"paged":"V_78l2"};